import { render, staticRenderFns } from "./icon2.vue?vue&type=template&id=776044df&scoped=true&"
import script from "./icon2.vue?vue&type=script&lang=js&"
export * from "./icon2.vue?vue&type=script&lang=js&"
import style0 from "./icon2.vue?vue&type=style&index=0&id=776044df&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776044df",
  null
  
)

export default component.exports